import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchLeadStatuses } from '../../services/crmServices/leadStatusService';

// Async thunk for fetching lead statuses
export const fetchLeadStatusesAsync = createAsyncThunk(
  'leadStatus/fetchLeadStatuses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchLeadStatuses();
      return response.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  statuses: [],
  loading: false,
  error: null,
};

const leadStatusSlice = createSlice({
  name: 'leadStatus',
  initialState,
  reducers: {
    addLeadStatus: (state, action) => {
      state.statuses.push(action.payload);
    },
    updateLeadStatus: (state, action) => {
      const index = state.statuses.findIndex(status => status._id === action.payload._id);
      if (index !== -1) {
        state.statuses[index] = action.payload;
      }
    },
    removeLeadStatus: (state, action) => {
      state.statuses = state.statuses.filter(status => status._id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeadStatusesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeadStatusesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.statuses = action.payload;
      })
      .addCase(fetchLeadStatusesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addLeadStatus, updateLeadStatus, removeLeadStatus } = leadStatusSlice.actions;

// Selectors
export const selectLeadStatuses = (state) => state.leadStatus.statuses;
export const selectLeadStatusesLoading = (state) => state.leadStatus.loading;
export const selectLeadStatusesError = (state) => state.leadStatus.error;

export default leadStatusSlice.reducer;